import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Services', to: '/services' },
  { label: 'Our Approach', to: '/performance' },
  { label: 'Portfolio', to: '/portfolio' },
  { label: 'About', to: '/about' },
  { label: 'Our Culture', to: '/culture' },
  { label: 'Partner With Us', to: '/partner' },
  { label: 'Contact', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        {/* Top row */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/390fbdda-ccd9-47f3-ab63-db1f61ff7592/18dc2a58-51dc-414a-b658-4a632eef1ab9_vectorized360hospnobackground.png?v=3ae9bb5e7d18760fcad351900ce2812a"
                alt="360 Hospitality Group"
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-gray-400 font-light leading-relaxed mb-6 max-w-xs">
              Florida&apos;s Performance-First Hotel Management Partner.
            </p>
            {/* Socials */}
            <div className="flex items-center space-x-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-700 text-gray-400 hover:bg-amber-500 hover:border-amber-500 hover:text-white transition-all" aria-label="Facebook">
                <i className="ri-facebook-fill text-base"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-700 text-gray-400 hover:bg-amber-500 hover:border-amber-500 hover:text-white transition-all" aria-label="Twitter">
                <i className="ri-twitter-x-fill text-base"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-700 text-gray-400 hover:bg-amber-500 hover:border-amber-500 hover:text-white transition-all" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-base"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-700 text-gray-400 hover:bg-amber-500 hover:border-amber-500 hover:text-white transition-all" aria-label="Instagram">
                <i className="ri-instagram-fill text-base"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-medium text-white uppercase tracking-[0.2em] mb-6">Navigation</h4>
            <ul className="space-y-3">
              {navLinks.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.to}
                    className="text-sm font-light text-gray-400 hover:text-amber-400 transition-colors flex items-center group whitespace-nowrap"
                  >
                    <i className="ri-arrow-right-line mr-2 opacity-0 group-hover:opacity-100 transition-opacity text-amber-400 text-xs"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-medium text-white uppercase tracking-[0.2em] mb-6">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-amber-400 text-sm"></i>
                </div>
                <p className="text-sm font-light text-gray-400 leading-relaxed">
                  301 Tucker Lane<br />Cocoa, Florida 32926
                </p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-amber-400 text-sm"></i>
                </div>
                <a href="tel:321-336-8093" className="text-sm font-light text-gray-400 hover:text-amber-400 transition-colors whitespace-nowrap">
                  321-336-8093
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-amber-400 text-sm"></i>
                </div>
                <a href="mailto:info@360hospitalitygroup.com" className="text-sm font-light text-gray-400 hover:text-amber-400 transition-colors">
                  info@360hospitalitygroup.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-500 font-light">
              &copy; 2026 360 Hospitality Group LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-xs text-gray-500 hover:text-amber-400 transition-colors font-light whitespace-nowrap">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-xs text-gray-500 hover:text-amber-400 transition-colors font-light whitespace-nowrap">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
